
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
		  //获取订单信息
		  getOrderInfo:`/apis/moyin-account/video/template/pay/order/info`,
          //下单
		  createOrder:`post /apis/moyin-account/video/template/pay/order`,
          //测试下单版本 -可删除
		  //createOrderTest:`get /apis/tts-web-api/v2/voice/clone/h5/pay?taskId=61d86b9c-2d7c-4c1b-97f2-159fdb8624e1`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"videoWechatPayPage"
			})
		}